import axiosInstance from 'api/axios';
import { APIResponse, APIUserGifs } from '../types';
import endpoints from '../gifMakerEndPoints';
interface SaveGifRequest {
  video_url: string;
  title: string;
}
function isFileType(file: string | File | null): file is File {
  return file instanceof File;
}

export const gifService = {
  // Generate gif
  generateGif: async (
    image_url: string,
    prompt: string,
    signal?: AbortSignal
  ): Promise<APIResponse<{ data: string }>> => {
    const response = await axiosInstance.private.post(
      endpoints.GenerateGif,
      { image_url: image_url, prompt: prompt },
      {
        signal,
      }
    );
    // console.log('done');
    return response.data.data?.image_url;
  },
  generateImageUrl: async (
    file: File | string | null,
    signal?: AbortSignal
  ): Promise<APIResponse<string>> => {
    let fileData: File | null = null;
    if (isFileType(file)) {
      fileData = file;
    }
    if (!fileData) {
      throw new Error('Invalid file input');
    }
    const formData = new FormData();
    formData.append('file', fileData);
    console.log(file);
    const response = await axiosInstance.image.post(
      endpoints.genearteImageUrl,
      formData,
      {
        signal,
      }
    );
    return response.data.data.url;
  },
  saveGif: async (
    data: SaveGifRequest
  ): Promise<APIResponse<{ data: string }>> => {
    {
      const response = await axiosInstance.private.post(
        endpoints.saveGif,
        {},
        {
          params: {
            video_url: data.video_url,
            title: data.title,
          },
        }
      );
      return response.data;
    }
  },
  getUserGifs: async (): Promise<APIResponse<APIUserGifs[]>> => {
    const response = await axiosInstance.private.get(endpoints.getUserGifs);
    return response.data.data;
  },
  getAllGifs: async (): Promise<APIResponse<APIUserGifs[]>> => {
    const response = await axiosInstance.public.get(endpoints.getGifs);
    return response.data.data;
  },
  deleteGifById: async (id: number): Promise<APIResponse<{ data: string }>> => {
    const response = await axiosInstance.private.post(
      endpoints.deleteGif,
      {},
      {
        params: {
          gif_id: id,
        },
      }
    );
    return response.data;
  },
  updateGifById: async (data: {
    id: number;
    fileName: string;
  }): Promise<APIResponse<{ data: string }>> => {
    const response = await axiosInstance.private.post(
      endpoints.updateTitle,
      {},
      {
        params: {
          gif_id: data.id,
          title: data.fileName,
        },
      }
    );
    console.log('done gif saved', response);
    return response.data;
  },
};
